import React, { useContext, useState } from "react";
import { AppBar, Toolbar, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Brand from "../../../design/Brand";
import SearchIcon from "@mui/icons-material/Search";
import { ThemeContext } from "../context/ThemeContext"; // Импортируем ThemeContext

function Navbar() {
  const { theme } = useContext(ThemeContext); // Достаём текущую тему из контекста
  const navigate = useNavigate();
  const navbarHex = /^#[0-9a-f]{6}$/i.test(theme.navbarColor || '') ? theme.navbarColor.slice(1) : 'ffffff';
  const navbarLuminance = [0.299, 0.587, 0.114].reduce((sum, weight, index) => sum + weight * parseInt(navbarHex.slice(index*2, index*2+2),16),0);
  const [search, setSearch] = useState('');
  const sections = [['Активы', '/assets'], ['Клиенты', '/clients'], ['Сделки', '/rental-deals'], ['Возвраты', '/returns'], ['Заявки', '/applications'], ['Отчеты', '/reports'], ['Мессенджер', '/messenger'], ['Настройки', '/settings']];

  const handleLogout = () => {
    // Полная очистка всех токенов и данных пользователя
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user_email");
    localStorage.removeItem("subscription_expired");
    
    // Дополнительная очистка всех ключей, содержащих "token"
    Object.keys(localStorage).forEach(key => {
      if (key.toLowerCase().includes('token')) {
        localStorage.removeItem(key);
      }
    });
    
    console.log("🚪 Полный выход - все токены очищены");
    navigate("/login");
  };

  return (
    <AppBar className="erp-navbar"
      position="fixed" 
      style={{ 
        "--erp-navbar-bg": theme.navbarColor || "#fff",
        "--erp-navbar-ink": navbarLuminance < 140 ? "#fff" : "#0b1634",
        backgroundColor: theme.navbarColor,
        zIndex: 1201 // Выше чем стандартные элементы, но ниже модальных окон
      }}
    >
      <Toolbar>
        <Brand to="/dashboard" />
        <div className="erp-search">
          <SearchIcon fontSize="small" />
          <input aria-label="Найти раздел ERP" placeholder="Поиск раздела: клиенты, активы, сделки…" value={search} onChange={event => setSearch(event.target.value)} />
          {search && <div className="erp-search-results">{sections.filter(([label]) => label.toLowerCase().includes(search.toLowerCase())).map(([label, path]) => <Link key={path} to={path} onClick={() => setSearch('')}>{label}</Link>)}{!sections.some(([label]) => label.toLowerCase().includes(search.toLowerCase())) && <span>Раздел не найден</span>}</div>}
        </div>
        <div style={{ flex: 1 }} />
        <Button color="inherit" component={Link} to="/profile">
          Профиль
        </Button>
        <Button color="inherit" onClick={handleLogout}>
          Выход
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
